module.exports = __webpack_public_path__ + "6b585c4e5745ba430c6493fcbd6c847d.svg";